import { useEffect, useState } from 'react';
import TrialBookingSection from './components/TrialBookingSection';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openLineRegistration = () => {
    alert(
      '公式LINEアカウント登録ページへ移動します。\n※実際の運用時は、こちらにLINE公式アカウントのURLを設定してください。'
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF5F0] via-white to-[#F0F7FF]">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 md:gap-3">
            <img
              src="https://static.readdy.ai/image/c625476636ef4a440cf8c0c2f14beac4/0d432776f5e1ced9a693745080ebdb1b.png"
              alt="At体育塾岡山・北長瀬校"
              className="h-10 md:h-14 w-auto drop-shadow-md"
            />
            <span
              className={`text-sm md:text-xl font-black transition-colors bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] bg-clip-text text-transparent`}
            >
              At 体育塾 岡山・北長瀬
            </span>
          </div>
          <div className="hidden md:flex items-center gap-6">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-base font-bold transition-all hover:text-[#FF6B35] hover:scale-105 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-gray-900'
              }`}
            >
              ホーム
            </button>
            <button
              onClick={() => scrollToSection('problem')}
              className={`text-base font-bold transition-all hover:text-[#FF6B35] hover:scale-105 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-gray-900'
              }`}
            >
              こんなお悩みに
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-base font-bold transition-all hover:text-[#FF6B35] hover:scale-105 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-gray-900'
              }`}
            >
              謲師紹介
            </button>
            <button
              onClick={() => scrollToSection('curriculum')}
              className={`text-base font-bold transition-all hover:text-[#FF6B35] hover:scale-105 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-gray-900'
              }`}
            >
              カリキュラム
            </button>
            <button
              onClick={() => scrollToSection('schedule')}
              className={`text-base font-bold transition-all hover:text-[#FF6B35] hover:scale-105 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-gray-900'
              }`}
            >
              料金・スケジュール
            </button>
            <button
              onClick={() => scrollToSection('trial-booking')}
              className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-6 py-3 rounded-full text-base font-bold hover:shadow-lg hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-md"
            >
              無料体験予約
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="pt-24 md:pt-32 pb-12 md:pb-20 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Large Logo Display */}
          <div className="flex justify-center mb-8 md:mb-12">
            <img
              src="https://static.readdy.ai/image/c625476636ef4a440cf8c0c2f14beac4/0d432776f5e1ced9a693745080ebdb1b.png"
              alt="At体育塾岡山・北長瀬校 ロゴ"
              className="h-32 md:h-48 lg:h-56 w-auto drop-shadow-2xl"
            />
          </div>
          <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center">
            <div className="space-y-6 md:space-y-8 order-last md:order-first">
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-sm md:text-base font-bold shadow-lg">
                <div className="w-2 md:w-2.5 h-2 md:h-2.5 bg-white rounded-full animate-pulse"></div>
                岡山の子供たちから日本に活力を!! ✨
              </div>
              <div>
                <h1 className="text-3xl md:text-6xl font-black text-transparent bg-gradient-to-r from-[#FF6B35] via-[#FF8C5A] to-[#FFB347] bg-clip-text mb-3 md:mb-4 leading-tight drop-shadow-lg animate-pulse">
                  At 体育塾 岡山・北長瀬
                </h1>
                <p className="text-lg md:text-2xl font-bold bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] bg-clip-text text-transparent">
                  発育発達理論に基づいた体操教室
                </p>
              </div>
              <p className="text-base md:text-lg text-gray-700 font-medium">
                日本スポーツ協会認定アスレティックトレーナーによる専門指導 🏃‍♂️
              </p>

              {/* Schedule Info */}
              <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-6 shadow-xl border-2 md:border-4 border-[#FFE5D9]">
                <div className="flex items-center gap-2 mb-3 md:mb-4">
                  <div className="w-8 md:w-10 h-8 md:h-10 bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-full flex items-center justify-center">
                    <i className="ri-calendar-line text-white text-lg md:text-xl"></i>
                  </div>
                  <h3 className="text-lg md:text-xl font-black text-gray-900">
                    開講スケジュール
                  </h3>
                </div>
                <div className="space-y-3">
                  <div className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-4 py-3 rounded-xl text-center mb-4">
                    <div className="text-xl md:text-2xl font-black mb-1">🎉 初月の3月は全クラス無料開講！</div>
                    <div className="text-sm md:text-base font-bold">（要予約・各クラス6名まで）</div>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm md:text-base">
                      <thead>
                        <tr className="border-b-2 border-gray-200">
                          <th className="text-left py-2 px-2 font-black text-gray-900 w-20">曜日</th>
                          <th className="text-left py-2 px-2 font-black text-gray-900 w-28">時間</th>
                          <th className="text-left py-2 px-2 font-black text-gray-900">クラス</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-b border-gray-100 bg-[#FFF5F0]">
                          <td className="py-2 px-2" rowSpan={2}>
                            <span className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-2 py-1 rounded-lg text-sm font-bold">月</span>
                          </td>
                          <td className="py-2 px-2 font-medium text-gray-700">16:30〜17:15</td>
                          <td className="py-2 px-2 font-medium text-gray-700">園児クラス（年長）</td>
                        </tr>
                        <tr className="border-b border-gray-100 bg-[#FFF5F0]">
                          <td className="py-2 px-2 font-medium text-gray-700">17:30〜18:15</td>
                          <td className="py-2 px-2 font-medium text-gray-700">1・2年生コース</td>
                        </tr>
                        <tr className="border-b border-gray-100 bg-[#F0F9FF]">
                          <td className="py-2 px-2" rowSpan={2}>
                            <span className="bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] text-white px-2 py-1 rounded-lg text-sm font-bold">火</span>
                          </td>
                          <td className="py-2 px-2 font-medium text-gray-700">17:00〜17:45</td>
                          <td className="py-2 px-2 font-medium text-gray-700">3・4年生スポーツコース<span className="text-xs text-gray-500 ml-1">※</span></td>
                        </tr>
                        <tr className="border-b border-gray-100 bg-[#F0F9FF]">
                          <td className="py-2 px-2 font-medium text-gray-700">18:10〜18:55</td>
                          <td className="py-2 px-2 font-medium text-gray-700">5・6年生スポーツコース<span className="text-xs text-gray-500 ml-1">※</span></td>
                        </tr>
                        <tr className="border-b border-gray-100">
                          <td className="py-2 px-2">
                            <span className="bg-gray-400 text-white px-2 py-1 rounded-lg text-sm font-bold">水</span>
                          </td>
                          <td className="py-2 px-2 font-medium text-gray-400" colSpan={2}>休み</td>
                        </tr>
                        <tr className="border-b border-gray-100 bg-[#FFF5F0]">
                          <td className="py-2 px-2">
                            <span className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-2 py-1 rounded-lg text-sm font-bold">木</span>
                          </td>
                          <td className="py-2 px-2 font-medium text-gray-700">16:30〜17:15</td>
                          <td className="py-2 px-2 font-medium text-gray-700">3〜6年生運動苦手克服コース</td>
                        </tr>
                        <tr className="border-b border-gray-100 bg-[#F0F9FF]">
                          <td className="py-2 px-2" rowSpan={2}>
                            <span className="bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] text-white px-2 py-1 rounded-lg text-sm font-bold">金</span>
                          </td>
                          <td className="py-2 px-2 font-medium text-gray-700">16:30〜17:15</td>
                          <td className="py-2 px-2 font-medium text-gray-700">園児クラス（年長）</td>
                        </tr>
                        <tr className="border-b border-gray-100 bg-[#F0F9FF]">
                          <td className="py-2 px-2 font-medium text-gray-700">17:30〜18:15</td>
                          <td className="py-2 px-2 font-medium text-gray-700">4〜6年生体幹TRスペシャル</td>
                        </tr>
                        <tr className="bg-[#FFF5F0]">
                          <td className="py-2 px-2">
                            <span className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-2 py-1 rounded-lg text-sm font-bold">日</span>
                          </td>
                          <td className="py-2 px-2 font-medium text-gray-700">19:00〜19:50</td>
                          <td className="py-2 px-2 font-medium text-gray-700">
                            ジュニアサッカー特別コース（4・5・6年生）
                            <span className="text-xs text-[#FF6B35] ml-1 font-bold">⚽定員8名</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="text-xs text-gray-500 mt-2 font-medium">
                    ※スポーツコースは競技スポーツを習っているJr.アスリート限定
                  </div>
                  <div className="text-xs text-gray-600 mt-2 font-bold bg-yellow-50 px-3 py-2 rounded-lg border border-yellow-200">
                    ※記載のクラスは4月からの新学年を基準としています。
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-3 md:gap-4">
                <button
                  onClick={openLineRegistration}
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#06C755] to-[#00B900] text-white font-bold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
                >
                  <i className="ri-line-fill"></i>
                  公式LINE登録
                </button>
                <a
                  href="tel:086-239-5959"
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white font-bold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap shadow-lg"
                >
                  <i className="ri-phone-fill"></i>
                  086-239-5959
                </a>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] text-white font-bold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
                >
                  お問い合わせ
                  <i className="ri-arrow-right-line"></i>
                </button>
                <a
                  href="http://at-home-kitanagase.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-white text-gray-900 font-bold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap border-2 border-gray-200"
                >
                  At Home 北長瀬
                  <i className="ri-external-link-line"></i>
                </a>
              </div>
            </div>

            <div className="relative order-first md:order-last">
              <div className="rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
                <img
                  src="https://static.readdy.ai/image/c625476636ef4a440cf8c0c2f14beac4/e2503e448059c055c063ce4a21169cab.jpeg"
                  alt="At体育塾岡山・北長瀬校 - 子どもたちの笑顔"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trial Booking Section - 開講スケジュール下に配置 */}
      <TrialBookingSection />

      {/* Soccer Special Course Banner */}
      <section className="py-8 md:py-12 px-4 md:px-6 bg-gradient-to-br from-[#FFF5F0] via-white to-[#F0F9FF]">
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-r from-[#FF6B35] via-[#FF8C5A] to-[#FFB347] rounded-2xl md:rounded-3xl p-6 md:p-10 shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-48 h-48 md:w-64 md:h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 md:w-48 md:h-48 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
            <div className="relative z-10">
              <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
                <div className="w-20 md:w-28 h-20 md:h-28 bg-white/20 backdrop-blur-sm rounded-2xl md:rounded-3xl flex items-center justify-center flex-shrink-0 shadow-xl">
                  <i className="ri-football-line text-5xl md:text-7xl text-white"></i>
                </div>
                <div className="flex-1 text-center md:text-left">
                  <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-1.5 rounded-full text-xs md:text-sm font-bold mb-3">
                    <i className="ri-star-fill"></i>
                    日曜日限定・定員8名
                  </div>
                  <h3 className="text-2xl md:text-4xl font-black text-white mb-3 md:mb-4 leading-tight">
                    ⚽ ジュニアサッカー特別コース
                  </h3>
                  <p className="text-white/90 text-base md:text-lg font-bold mb-4">
                    サッカーをしている4年生〜6年生限定の特別クラス
                  </p>
                  <div className="grid md:grid-cols-3 gap-3 md:gap-4 mb-5">
                    <div className="bg-white/20 backdrop-blur-sm rounded-xl p-3 md:p-4">
                      <div className="text-white text-xs md:text-sm font-bold mb-1">⏰ 時間</div>
                      <div className="text-white text-sm md:text-base font-black">日曜 19:00〜19:50</div>
                    </div>
                    <div className="bg-white/20 backdrop-blur-sm rounded-xl p-3 md:p-4">
                      <div className="text-white text-xs md:text-sm font-bold mb-1">👥 定員</div>
                      <div className="text-white text-sm md:text-base font-black">8名（他クラスより多め）</div>
                    </div>
                    <div className="bg-white/20 backdrop-blur-sm rounded-xl p-3 md:p-4">
                      <div className="text-white text-xs md:text-sm font-bold mb-1">🎯 対象</div>
                      <div className="text-white text-sm md:text-base font-black">4・5・6年生</div>
                    </div>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 md:p-5 mb-5">
                    <div className="text-white font-black mb-2 md:mb-3 text-base md:text-lg">📚 レッスン内容</div>
                    <div className="grid md:grid-cols-3 gap-2 md:gap-3 text-sm md:text-base">
                      <div className="flex items-center gap-2 text-white font-medium">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                          <i className="ri-check-line text-lg"></i>
                        </div>
                        サッカーに必要なコアTR
                      </div>
                      <div className="flex items-center gap-2 text-white font-medium">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                          <i className="ri-check-line text-lg"></i>
                        </div>
                        全身可動性エクササイズ
                      </div>
                      <div className="flex items-center gap-2 text-white font-medium">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                          <i className="ri-check-line text-lg"></i>
                        </div>
                        闘う為の体のお勉強
                      </div>
                    </div>
                    <div className="text-white/80 text-xs md:text-sm mt-2 md:mt-3 font-medium">
                      ※栄養・休養・準備など、サッカー選手として必要な知識も学べます
                    </div>
                  </div>
                  <button
                    onClick={() => scrollToSection('trial-booking')}
                    className="inline-flex items-center gap-2 bg-white text-[#FF6B35] font-bold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
                  >
                    <i className="ri-calendar-check-line"></i>
                    このコースを予約する
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* At Home Banner */}
      <section className="py-6 md:py-8 px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <a
            href="http://at-home-kitanagase.com"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-xl hover:shadow-2xl hover:scale-105 transition-all cursor-pointer"
          >
            <div className="flex items-center justify-between">
              <div className="space-y-1 md:space-y-2">
                <div className="text-white text-sm md:text-base font-bold">
                  ~Jリーグ経験トレーナーの整体院~
                </div>
                <div className="text-white text-xl md:text-2xl font-black">
                  At Home 北長瀬
                </div>
                <div className="text-white/90 text-base md:text-lg font-medium">
                  鍼灸・整体院
                </div>
              </div>
              <div className="w-12 md:w-16 h-12 md:h-16 bg-white rounded-full flex items-center justify-center">
                <i className="ri-external-link-line text-2xl md:text-3xl text-[#0EA5E9]"></i>
              </div>
            </div>
          </a>
        </div>
      </section>

      {/* Problem Section */}
      <section
        id="problem"
        className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-br from-[#E0F2FE] to-[#F0F9FF]"
      >
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-sm md:text-base font-bold shadow-lg mb-4 md:mb-6">
              <div className="w-2 md:w-2.5 h-2 md:h-2.5 bg-white rounded-full"></div>
              こんなお悩みありませんか？
            </div>
            <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-4 md:mb-6 leading-tight">
              At体育塾岡山・北長瀬校が<br />
              解決します！ 💪
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 space-y-3 md:space-y-4 hover:shadow-xl transition-all hover:scale-105 border-2 md:border-4 border-[#E0F2FE]">
              <div className="w-12 md:w-16 h-12 md:h-16 bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-emotion-sad-line text-white text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                体力が心配...
              </h3>
              <p className="text-gray-600 leading-relaxed font-medium text-sm md:text-base">
                最近の子どもは外で遊ぶ機会が減って、体力が低下しています。スマホやゲームばかりで運動不足が心配...
              </p>
            </div>
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 space-y-3 md:space-y-4 hover:shadow-xl transition-all hover:scale-105 border-2 md:border-4 border-[#E0F2FE]">
              <div className="w-12 md:w-16 h-12 md:h-16 bg-gradient-to-br from-[#0EA5E9] to-[#38BDF8] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-book-line text-white text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                学校の体育だけでは...
              </h3>
              <p className="text-gray-600 leading-relaxed font-medium text-sm md:text-base">
                学校の体育の授業時間が減って、多様な運動経験を積む機会が限られています。もっと専門的な指導を受けさせたい...
              </p>
            </div>
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 space-y-3 md:space-y-4 hover:shadow-xl transition-all hover:scale-105 border-2 md:border-4 border-[#E0F2FE]">
              <div className="w-12 md:w-16 h-12 md:h-16 bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-heart-pulse-line text-white text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                怪我が心配...
              </h3>
              <p className="text-gray-600 leading-relaxed font-medium text-sm md:text-base">
                1つのスポーツばかりやっていると体のバランスが偏って怪我のリスクが高まります。バランスよく体を鍛えたい...
              </p>
            </div>
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 space-y-3 md:space-y-4 hover:shadow-xl transition-all hover:scale-105 border-2 md:border-4 border-[#FFE5D9]">
              <div className="w-12 md:w-16 h-12 md:h-16 bg-gradient-to-br from-[#FFB347] to-[#FF8C5A] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-trophy-line text-white text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                もっと活躍したい！
              </h3>
              <p className="text-gray-600 leading-relaxed font-medium text-sm md:text-base">
                競技スポーツのクラブに入っているけど、もっと良い成績を出したい。ライバルに差をつけて活躍したい...
              </p>
            </div>
          </div>
          <div className="mt-8 md:mt-12 text-center">
            <div className="inline-block bg-white rounded-2xl md:rounded-3xl px-6 md:px-8 py-5 md:py-6 shadow-xl mb-4 md:mb-6 border-2 border-[#0EA5E9]/20">
              <p className="text-xl md:text-2xl font-black text-gray-900 mb-2">
                At体育塾岡山・北長瀬校なら全て解決！ ✨
              </p>
              <p className="text-gray-600 font-medium text-sm md:text-base">
                専門トレーナーによる科学的なアプローチで<br />
                お子様の健やかな成長をサポートします
              </p>
            </div>
            <div className="flex justify-center">
              <button
                onClick={openLineRegistration}
                className="inline-flex items-center gap-2 bg-gradient-to-r from-[#06C755] to-[#00B900] text-white font-bold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
              >
                <i className="ri-line-fill"></i>
                公式LINEで予約する
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 md:py-24 px-4 md:px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-5 gap-8 md:gap-16 items-center">
            <div className="md:col-span-3 space-y-6 md:space-y-8">
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-sm md:text-base font-bold shadow-lg">
                <div className="w-2 md:w-2.5 h-2 md:h-2.5 bg-white rounded-full"></div>
                謲師紹介
              </div>
              <div className="space-y-4 md:space-y-6">
                <blockquote className="text-2xl md:text-3xl font-black text-gray-900 leading-relaxed">
                  <span className="text-4xl md:text-5xl text-[#FF6B35]">"</span>
                  岡山の子供たちから日本に活力を!! 🌟
                </blockquote>
                <div className="flex items-center gap-3 md:gap-4">
                  <div>
                    <div className="text-xl md:text-2xl font-black text-gray-900">
                      辻 卓也
                    </div>
                    <div className="flex items-center gap-2 mt-2">
                      <div className="w-6 md:w-7 h-6 md:h-7 bg-gradient-to-br from-[#0EA5E9] to-[#38BDF8] rounded-full flex items-center justify-center shadow-md">
                        <i className="ri-star-fill text-white text-xs md:text-sm"></i>
                      </div>
                      <span className="text-sm md:text-base text-gray-700 font-bold">
                        日本スポーツ協会認定アスレティックトレーナー
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="space-y-3 md:space-y-4 pt-2 md:pt-4">
                <p className="text-gray-700 leading-relaxed font-medium text-sm md:text-base">
                  サッカーJ1リーグのトレーナーとしても活躍した経験を持つ、日本スポーツ協会認定アスレティックトレーナー。
                </p>
                <p className="text-gray-700 leading-relaxed font-medium text-sm md:text-base">
                  At Home 北長瀬という鍼灸・整体の事業を展開しながら、子どもたちの健やかな成長をサポートするため、At体育塾岡山・北長瀬校を開講しました。
                </p>
                <p className="text-gray-700 leading-relaxed font-medium text-sm md:text-base">
                  発育発達理論に基づいたカリキュラムで、スポーツの世界で活躍してほしい、体育の授業だけでは不安、子どもの姿勢や体力に不安があるなどの悩みを持つ保護者の皆様をサポートします。
                </p>
              </div>
              <a
                href="http://at-home-kitanagase.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] text-white font-bold text-sm md:text-base px-5 md:px-6 py-2.5 md:py-3 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap shadow-lg"
              >
                At Home 北長瀬について
                <i className="ri-external-link-line"></i>
              </a>
            </div>
            <div className="md:col-span-2">
              <div className="relative h-96 md:h-[600px] rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl border-2 md:border-4 border-white">
                <img
                  src="https://static.readdy.ai/image/c625476636ef4a440cf8c0c2f14beac4/a03d3c4cb95907bc20b1902f1fb7039a.jpeg"
                  alt="辻卓也トレーナー"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Curriculum Section */}
      <section
        id="curriculum"
        className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-br from-[#FFF5F0] to-[#FFE5D9]"
      >
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 md:mb-16 text-center">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-sm md:text-base font-bold shadow-lg mb-4 md:mb-6">
              <div className="w-2 md:w-2.5 h-2 md:h-2.5 bg-white rounded-full"></div>
              カリキュラム
            </div>
            <h2 className="text-2xl md:text-4xl font-black text-gray-900 leading-tight">
              多彩なプログラムで<br />
              楽しく体を鍛える 🎯
            </h2>
          </div>

          {/* 子どもたちの活動写真 */}
          <div className="grid md:grid-cols-3 gap-4 md:gap-6 mb-12">
            <div className="relative h-48 md:h-64 rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border-4 border-white">
              <img
                src="https://public.readdy.ai/ai/img_res/32c78aa47fce061e55aac43a5d3037cc.jpg"
                alt="マット運動を楽しむ子どもたち"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="relative h-48 md:h-64 rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border-4 border-white">
              <img
                src="https://readdy.ai/api/search-image?query=japanese%20children%20practicing%20balance%20training%20exercises%20with%20big%20smiles%2C%20bright%20gymnasium%20interior%2C%20active%20and%20fun%20atmosphere%2C%20professional%20photography%2C%20clean%20background%2C%20natural%20lighting&width=500&height=400&seq=athome008&orientation=landscape"
                alt="バランストレーニングを楽しむ子どもたち"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="relative h-48 md:h-64 rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border-4 border-white">
              <img
                src="https://readdy.ai/api/search-image?query=group%20of%20cheerful%20japanese%20children%20doing%20coordination%20training%20with%20colorful%20equipment%2C%20laughing%20and%20having%20fun%2C%20bright%20modern%20sports%20facility%2C%20professional%20photography%2C%20clean%20white%20walls&width=500&height=400&seq=athome009&orientation=landscape"
                alt="コオーディネーショントレーニングを楽しむ子どもたち"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 space-y-4 md:space-y-6 hover:shadow-2xl transition-all hover:scale-105 border-2 md:border-4 border-[#FFE5D9]">
              <div className="w-16 md:w-20 h-16 md:h-20 bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-user-star-line text-4xl md:text-5xl text-white"></i>
              </div>
              <div className="text-2xl md:text-3xl font-black bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] bg-clip-text text-transparent">
                マット体操・鉄棒
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                マット運動・体操
              </h3>
              <p className="text-gray-700 leading-relaxed font-medium text-sm md:text-base">
                前転、後転、側転などの基本的なマット運動を通じて、体の使い方や空間認識能力を高めます。柔軟性と協調性も同時に育成します。
              </p>
            </div>
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 space-y-4 md:space-y-6 hover:shadow-2xl transition-all hover:scale-105 border-2 md:border-4 border-[#E0F2FE]">
              <div className="w-16 md:w-20 h-16 md:h-20 bg-gradient-to-br from-[#0EA5E9] to-[#38BDF8] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-footprint-line text-4xl md:text-5xl text-white"></i>
              </div>
              <div className="text-2xl md:text-3xl font-black bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] bg-clip-text text-transparent">
                ステップワーク
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                ステップワーク
              </h3>
              <p className="text-gray-700 leading-relaxed font-medium text-sm md:text-base">
                様々な方向への素早い動きや切り返しを練習することで、俊敏性とリズム感を養います。あらゆるスポーツに応用できる基礎能力です。
              </p>
            </div>
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 space-y-4 md:space-y-6 hover:shadow-2xl transition-all hover:scale-105 border-2 md:border-4 border-[#FFE5D9]">
              <div className="w-16 md:w-20 h-16 md:h-20 bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-heart-pulse-line text-4xl md:text-5xl text-white"></i>
              </div>
              <div className="text-2xl md:text-3xl font-black bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] bg-clip-text text-transparent">
                体幹・バランストレーニング
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                体幹トレーニング
              </h3>
              <p className="text-gray-700 leading-relaxed font-medium text-sm md:text-base">
                体の中心となる体幹を鍛えることで、あらゆるスポーツの基礎となる安定した姿勢とバランス感覚を養います。正しい姿勢づくりにも効果的です。
              </p>
            </div>
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 space-y-4 md:space-y-6 hover:shadow-2xl transition-all hover:scale-105 border-2 md:border-4 border-[#E0F2FE]">
              <div className="w-16 md:w-20 h-16 md:h-20 bg-gradient-to-br from-[#0EA5E9] to-[#38BDF8] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-brain-line text-4xl md:text-5xl text-white"></i>
              </div>
              <div className="text-2xl md:text-3xl font-black bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] bg-clip-text text-transparent">
                コオーディネーショントレーニング
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                脳と体を繋げる
              </h3>
              <p className="text-gray-700 leading-relaxed font-medium text-sm md:text-base">
                7つの能力（リズム能力・バランス能力・連結能力・反応能力・変換能力・定位能力・識別能力）を高めるトレーニング。脳からの指令を素早く正確に体に伝える能力を養い、運動神経の発達を促進します。あらゆるスポーツの基礎となる重要なトレーニングです。
              </p>
            </div>
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 space-y-4 md:space-y-6 hover:shadow-2xl transition-all hover:scale-105 border-2 md:border-4 border-[#FFE5D9]">
              <div className="w-16 md:w-20 h-16 md:h-20 bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-basketball-line text-4xl md:text-5xl text-white"></i>
              </div>
              <div className="text-2xl md:text-3xl font-black bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] bg-clip-text text-transparent">
                各種スポーツ動作トレーニング
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                各種スポーツ動作トレーニング
              </h3>
              <p className="text-gray-700 leading-relaxed font-medium text-sm md:text-base">
                サッカー、野球、バスケットボール、バレーボール、テニスなど、様々なスポーツに共通する基本動作を習得。専門競技への応用力を高めます。
              </p>
            </div>
            <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 space-y-4 md:space-y-6 hover:shadow-2xl transition-all hover:scale-105 border-2 md:border-4 border-[#E0F2FE]">
              <div className="w-16 md:w-20 h-16 md:h-20 bg-gradient-to-br from-[#0EA5E9] to-[#38BDF8] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-game-line text-4xl md:text-5xl text-white"></i>
              </div>
              <div className="text-2xl md:text-3xl font-black bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] bg-clip-text text-transparent">
                けん玉・ジャグリング
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900">
                けん玉・ジャグリング
              </h3>
              <p className="text-gray-700 leading-relaxed font-medium text-sm md:text-base">
                楽しみながら集中力と手先の器用さを養います。目と手の協調性を高め、運動神経の発達を促進します。
              </p>
            </div>
          </div>
          <div className="mt-8 md:mt-12 text-center">
            <button
              onClick={openLineRegistration}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-[#06C755] to-[#00B900] text-white font-bold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              <i className="ri-line-fill"></i>
              公式LINEで体験予約
            </button>
          </div>
        </div>
      </section>

      {/* Pricing Plan Section */}
      <section id="pricing-plan" className="py-16 md:py-24 px-4 md:px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-sm md:text-base font-bold shadow-lg mb-4 md:mb-6">
              <div className="w-2 md:w-2.5 h-2 md:h-2.5 bg-white rounded-full"></div>
              料金プラン
            </div>
            <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-3 md:mb-4 leading-tight">
              シンプルでわかりやすい<br />料金体系 💰
            </h2>
            <p className="text-gray-600 text-sm md:text-base font-medium max-w-2xl mx-auto">
              お子様の成長に合わせたコースをお選びいただけます。<br className="hidden md:block" />初月の3月は全クラス無料で体験いただけます！
            </p>
            <div className="text-xs text-gray-600 mt-3 font-bold bg-yellow-50 px-4 py-2 rounded-lg border border-yellow-200 inline-block">
              ※記載のクラスは4月からの新学年を基準としています。
            </div>
          </div>

          {/* Campaign Banner */}
          <div className="mb-8 md:mb-12">
            <div className="bg-gradient-to-r from-[#FF6B35] to-[#FFB347] rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-xl relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 md:w-48 md:h-48 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 md:w-36 md:h-36 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
              <div className="relative z-10 text-center">
                <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-1.5 rounded-full text-sm font-bold mb-3">
                  <i className="ri-gift-line"></i>
                  期間限定キャンペーン
                </div>
                <div className="text-white text-2xl md:text-4xl font-black mb-2">
                  🎉 初月の3月は全クラス無料開講！
                </div>
                <div className="text-white/90 text-sm md:text-base font-bold">
                  要予約・各クラス先着6名まで
                </div>
              </div>
            </div>
          </div>

          {/* Pricing Cards */}
          <div className="grid md:grid-cols-3 gap-5 md:gap-8 mb-8 md:mb-12">
            {/* Registration Fee */}
            <div className="bg-gradient-to-br from-[#FFF5F0] to-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg border-2 border-[#FFE5D9] hover:shadow-xl transition-all hover:scale-105">
              <div className="w-14 md:w-16 h-14 md:h-16 bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg mb-5 md:mb-6">
                <i className="ri-user-add-line text-white text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900 mb-2">登録料</h3>
              <p className="text-gray-600 text-sm font-medium mb-4 md:mb-6">入会時に一度だけお支払いいただく費用です</p>
              <div className="flex items-end gap-1 mb-4">
                <span className="text-4xl md:text-5xl font-black bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] bg-clip-text text-transparent">¥1,000</span>
                <span className="text-gray-500 text-sm font-bold mb-1.5">（税込）</span>
              </div>
              <div className="space-y-2.5">
                <div className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#FF6B35] text-lg"></i>
                  </div>
                  初回のみのお支払い
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#FF6B35] text-lg"></i>
                  </div>
                  兄弟割引あり（2人目以降無料）
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#FF6B35] text-lg"></i>
                  </div>
                  スポーツ安全保険加入必須
                </div>
              </div>
            </div>

            {/* Monthly Fee - Featured */}
            <div className="bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-xl relative overflow-hidden hover:shadow-2xl transition-all hover:scale-105">
              <div className="absolute top-3 right-3 bg-white text-[#FF6B35] text-xs font-black px-3 py-1 rounded-full shadow-md">
                おすすめ
              </div>
              <div className="w-14 md:w-16 h-14 md:h-16 bg-white/20 backdrop-blur-sm rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg mb-5 md:mb-6">
                <i className="ri-calendar-check-line text-white text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl font-black text-white mb-2">月謝（週1回コース）</h3>
              <p className="text-white/80 text-sm font-medium mb-4 md:mb-6">月4回のレッスンで基礎体力を向上</p>
              <div className="flex items-end gap-1 mb-1">
                <span className="text-4xl md:text-5xl font-black text-white">¥5,500</span>
                <span className="text-white/80 text-sm font-bold mb-1.5">/ 月（税込）</span>
              </div>
              <div className="text-white/70 text-xs font-medium mb-4 md:mb-6">
                ※4月以降の通常料金
              </div>
              <div className="space-y-2.5">
                <div className="flex items-center gap-2 text-sm text-white font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  月4回（週1回）のレッスン
                </div>
                <div className="flex items-center gap-2 text-sm text-white font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  1回45分の充実した内容
                </div>
                <div className="flex items-center gap-2 text-sm text-white font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  少人数制（各クラス6名まで）
                </div>
                <div className="flex items-center gap-2 text-sm text-white font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  専門トレーナーによる指導
                </div>
              </div>
            </div>

            {/* Free Trial */}
            <div className="bg-gradient-to-br from-[#F0F9FF] to-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg border-2 border-[#0EA5E9]/20 hover:shadow-xl transition-all hover:scale-105">
              <div className="w-14 md:w-16 h-14 md:h-16 bg-gradient-to-br from-[#0EA5E9] to-[#38BDF8] rounded-xl md:rounded-2xl flex items-center justify-center shadow-lg mb-5 md:mb-6">
                <i className="ri-gift-2-line text-white text-2xl md:text-3xl"></i>
              </div>
              <h3 className="text-lg md:text-xl font-black text-gray-900 mb-2">3月限定 無料体験</h3>
              <p className="text-gray-600 text-sm font-medium mb-4 md:mb-6">初月は全クラス無料でお試しいただけます</p>
              <div className="flex items-end gap-1 mb-1">
                <span className="text-4xl md:text-5xl font-black bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] bg-clip-text text-transparent">¥0</span>
                <span className="text-gray-500 text-sm font-bold mb-1.5">/ 3月限定</span>
              </div>
              <div className="text-gray-400 text-xs font-medium mb-4 md:mb-6">
                ※要予約・先着順
              </div>
              <div className="space-y-2.5">
                <div className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#0EA5E9] text-lg"></i>
                  </div>
                  全クラス対象
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#0EA5E9] text-lg"></i>
                  </div>
                  登録料も無料
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#0EA5E9] text-lg"></i>
                  </div>
                  各クラス先着6名まで
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700 font-medium">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#0EA5E9] text-lg"></i>
                  </div>
                  公式LINEから簡単予約
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12">
            <div className="bg-[#FFF5F0] rounded-2xl p-5 md:p-6 border border-[#FFE5D9]">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-lg flex items-center justify-center">
                  <i className="ri-information-line text-white text-lg"></i>
                </div>
                <h4 className="font-black text-gray-900 text-base">お支払いについて</h4>
              </div>
              <ul className="space-y-2 text-sm text-gray-700 font-medium">
                <li className="flex items-start gap-2">
                  <span className="text-[#FF6B35] mt-0.5">•</span>
                  月謝は毎月口座振替でのお支払いとなります
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#FF6B35] mt-0.5">•</span>
                  登録料は初回レッスン時に現金でお支払いください
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#FF6B35] mt-0.5">•</span>
                  スポーツ安全保険料は別途必要です
                </li>
              </ul>
            </div>
            <div className="bg-[#F0F9FF] rounded-2xl p-5 md:p-6 border border-[#0EA5E9]/20">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 bg-gradient-to-br from-[#0EA5E9] to-[#38BDF8] rounded-lg flex items-center justify-center">
                  <i className="ri-calendar-line text-white text-lg"></i>
                </div>
                <h4 className="font-black text-gray-900 text-base">予約について</h4>
              </div>
              <ul className="space-y-2 text-sm text-gray-700 font-medium">
                <li className="flex items-start gap-2">
                  <span className="text-[#0EA5E9] mt-0.5">•</span>
                  毎月20日12:00から翌月分の予約受付開始
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#0EA5E9] mt-0.5">•</span>
                  先着順での受付となります
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#0EA5E9] mt-0.5">•</span>
                  公式LINEからのご予約がスムーズです
                </li>
              </ul>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <button
              onClick={openLineRegistration}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-[#06C755] to-[#00B900] text-white font-bold text-sm md:text-base px-8 md:px-10 py-3.5 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              <i className="ri-line-fill text-lg"></i>
              公式LINEで無料体験を予約する
            </button>
          </div>
        </div>
      </section>

      {/* Schedule & Pricing Section */}
      <section
        id="schedule"
        className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-br from-gray-900 to-gray-800"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 md:gap-12">
            <div className="space-y-6 md:space-y-8">
              <h2 className="text-2xl md:text-3xl font-black text-white">
                SCHEDULE ⏰
              </h2>
              <div className="space-y-4 md:space-y-6">
                <div className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] rounded-xl md:rounded-2xl p-5 md:p-6 shadow-lg">
                  <div className="text-white font-black mb-2 md:mb-3 text-base md:text-lg">
                    🎉 初月の3月限定
                  </div>
                  <div className="text-white font-bold text-xl md:text-2xl">
                    全クラス無料開講！
                  </div>
                  <div className="text-white/90 text-xs md:text-sm mt-1 md:mt-2">
                    ※要予約・各クラス6名まで
                  </div>
                </div>
                <div className="bg-yellow-500/20 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-4 border border-yellow-500/30">
                  <div className="text-yellow-300 text-xs md:text-sm font-bold text-center">
                    ※記載のクラスは4月からの新学年を基準としています。
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-5 md:p-6">
                  <div className="text-[#FF8C5A] font-black mb-2 md:mb-3 text-base md:text-lg">
                    月曜日
                  </div>
                  <div className="text-white text-sm md:text-base space-y-1 md:space-y-2 font-medium">
                    <div>16:30〜17:15 園児クラス（年長）</div>
                    <div>17:30〜18:15 1・2年生コース</div>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-5 md:p-6">
                  <div className="text-[#38BDF8] font-black mb-2 md:mb-3 text-base md:text-lg">
                    火曜日
                  </div>
                  <div className="text-white text-sm md:text-base space-y-1 md:space-y-2 font-medium">
                    <div>17:00〜17:45 3・4年生スポーツコース</div>
                    <div>18:10〜18:55 5・6年生スポーツコース</div>
                    <div className="text-gray-300 text-xs md:text-sm mt-1">
                      ※Jr.アスリート限定
                    </div>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-5 md:p-6">
                  <div className="text-gray-400 font-black mb-2 md:mb-3 text-base md:text-lg">
                    水曜日
                  </div>
                  <div className="text-gray-400 text-sm md:text-base font-medium">
                    休み
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-5 md:p-6">
                  <div className="text-[#FF8C5A] font-black mb-2 md:mb-3 text-base md:text-lg">
                    木曜日
                  </div>
                  <div className="text-white text-sm md:text-base space-y-1 md:space-y-2 font-medium">
                    <div>16:30〜17:15 3〜6年生</div>
                    <div className="text-gray-300 text-xs md:text-sm mt-1">
                      運動苦手克服コース
                    </div>
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-5 md:p-6 border-2 border-[#FF8C5A]/30">
                  <div className="flex items-center gap-2 mb-2 md:mb-3">
                    <i className="ri-football-line text-2xl text-[#FF8C5A]"></i>
                    <div className="text-[#FF8C5A] font-black text-base md:text-lg">
                      日曜日 ⚽特別コース
                    </div>
                  </div>
                  <div className="text-white text-sm md:text-base space-y-1 md:space-y-2 font-medium">
                    <div className="font-bold">19:00〜19:50</div>
                    <div>ジュニアサッカー特別コース</div>
                    <div className="text-gray-300 text-xs md:text-sm mt-1">
                      4・5・6年生限定・定員8名
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="pricing" className="space-y-4 md:space-y-6">
              <h2 className="text-2xl md:text-3xl font-black text-white">
                PRICING 💰
              </h2>
              <div className="space-y-3 md:space-y-4 text-sm md:text-base">
                <div className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] rounded-xl md:rounded-2xl p-4 md:p-5 shadow-lg">
                  <div className="font-black text-white mb-1 md:mb-2 text-base md:text-lg">
                    🎉 初月の3月限定キャンペーン
                  </div>
                  <div className="text-white font-bold text-xl md:text-2xl">
                    全クラス無料！
                  </div>
                  <div className="text-white/90 text-xs md:text-sm mt-1 md:mt-2">
                    ※要予約・各クラス6名まで
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-4 md:p-5">
                  <div className="font-black text-white mb-1 md:mb-2 text-base md:text-lg">
                    通常料金（4月以降）
                  </div>
                  <div className="text-gray-200 font-medium">
                    週1回コース（月4回）
                  </div>
                  <div className="text-white font-bold text-xl md:text-2xl mt-1">
                    ¥5,500
                  </div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-4 md:p-5">
                  <div className="font-black text-white mb-1 md:mb-2 text-base md:text-lg">
                    登録料
                  </div>
                  <div className="text-gray-200 font-medium">
                    初回のみ ¥1,000
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-4 md:space-y-6">
              <h2 className="text-2xl md:text-3xl font-black text-white">
                DETAILS 📋
              </h2>
              <div className="space-y-3 md:space-y-4 text-sm md:text-base">
                <div className="flex items-start gap-2 md:gap-3 bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-4">
                  <div className="w-7 md:w-8 h-7 md:h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-group-line text-[#38BDF8] text-lg md:text-xl"></i>
                  </div>
                  <div className="text-gray-200 font-medium">
                    <div className="font-black text-white mb-1">定員</div>
                    <div>各クラス6名まで</div>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-3 bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-4">
                  <div className="w-7 md:w-8 h-7 md:h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-[#FF8C5A] text-lg md:text-xl"></i>
                  </div>
                  <div className="text-gray-200 font-medium">
                    <div className="font-black text-white mb-1">時間</div>
                    <div>1回45分間</div>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-3 bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-4">
                  <div className="w-7 md:w-8 h-7 md:h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-[#38BDF8] text-lg md:text-xl"></i>
                  </div>
                  <div className="text-gray-200 font-medium">
                    <div className="font-black text-white mb-1">保険</div>
                    <div>スポーツ安全保険加入必須</div>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-3 bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-4">
                  <div className="w-7 md:w-8 h-7 md:h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-[#FF8C5A] text-lg md:text-xl"></i>
                  </div>
                  <div className="text-gray-200 font-medium">
                    <div className="font-black text-white mb-1">場所</div>
                    <div>
                      At Home 北長瀬
                      <br />
                      （鍼灸・整体院）内
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-3 bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-4">
                  <div className="w-7 md:w-8 h-7 md:h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-calendar-check-line text-[#38BDF8] text-lg md:text-xl"></i>
                  </div>
                  <div className="text-gray-200 font-medium">
                    <div className="font-black text-white mb-1">開講</div>
                    <div>2026年3月スタート</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-4 md:space-y-6">
              <div className="space-y-1 md:space-y-2">
                <div className="text-white text-lg md:text-xl font-black">
                  公式LINEから
                </div>
                <div className="text-white text-lg md:text-xl font-black">
                  簡単予約 📱
                </div>
              </div>
              <button
                onClick={openLineRegistration}
                className="w-full bg-gradient-to-r from-[#06C755] to-[#00B900] text-white font-bold text-sm md:text-base px-5 md:px-6 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg flex items-center justify-center gap-2"
              >
                <i className="ri-line-fill text-lg"></i>
                公式LINE登録
              </button>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-4 md:p-5">
                <div className="text-white font-black mb-2 text-sm md:text-base">
                  📅 予約受付について
                </div>
                <div className="text-gray-200 text-xs md:text-sm space-y-1 font-medium">
                  <div>毎月20日12:00から翌月分の予約受付開始</div>
                  <div className="text-[#FFB347] font-bold pt-1">※先着順・公式LINEより受付</div>
                </div>
              </div>
              <div className="text-xs md:text-sm text-gray-300 space-y-1 font-medium">
                <div>※初月の3月は全クラス無料開講</div>
                <div>※要予約・先着順</div>
                <div>※各クラス6名まで</div>
              </div>
              <a
                href="http://at-home-kitanagase.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] rounded-xl md:rounded-2xl p-4 md:p-5 hover:shadow-xl transition-all hover:scale-105"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-white text-xs md:text-sm font-bold mb-1">
                      運営元
                    </div>
                    <div className="text-white text-base md:text-lg font-black">
                      At Home 北長瀬
                    </div>
                  </div>
                  <i className="ri-external-link-line text-white text-xl md:text-2xl"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section
        id="contact"
        className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-br from-[#F0F9FF] to-white"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center">
            <div className="space-y-6 md:space-y-8">
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-sm md:text-base font-bold shadow-lg">
                <div className="w-2 md:w-2.5 h-2 md:h-2.5 bg-white rounded-full"></div>
                お問い合わせ
              </div>
              <div>
                <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-4 md:mb-6 leading-tight">
                  初月の3月は全クラス無料！
                  <br />
                  今すぐ予約しよう 🎉
                </h2>
                <div className="inline-block">
                  <span className="text-3xl md:text-4xl">✨🎊</span>
                </div>
              </div>
              <p className="text-base md:text-lg text-gray-700 font-medium">
                お気軽にお問い合わせください。公式LINEまたはお電話でのご予約がスムーズです。
              </p>
              
              {/* Phone Number Highlight */}
              <div className="bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] rounded-2xl md:rounded-3xl p-5 md:p-6 shadow-xl">
                <div className="flex items-center gap-3 md:gap-4">
                  <div className="w-12 md:w-14 h-12 md:h-14 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-fill text-2xl md:text-3xl text-[#FF6B35]"></i>
                  </div>
                  <div>
                    <div className="text-white text-sm md:text-base font-bold mb-1">
                      お電話でのお問い合わせ
                    </div>
                    <a
                      href="tel:086-239-5959"
                      className="text-white text-2xl md:text-3xl font-black hover:underline"
                    >
                      086-239-5959
                    </a>
                    <div className="text-white/90 text-xs md:text-sm mt-1">
                      At Home 北長瀬
                    </div>
                  </div>
                </div>
              </div>

              {/* Access Info */}
              <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-6 shadow-xl border-2 border-[#0EA5E9]/20">
                <div className="flex items-center gap-2 mb-3 md:mb-4">
                  <div className="w-8 md:w-10 h-8 md:h-10 bg-gradient-to-br from-[#0EA5E9] to-[#38BDF8] rounded-full flex items-center justify-center">
                    <i className="ri-map-pin-line text-white text-lg md:text-xl"></i>
                  </div>
                  <h3 className="text-lg md:text-xl font-black text-gray-900">
                    会場・アクセス
                  </h3>
                </div>
                <div className="space-y-2 text-sm md:text-base">
                  <div className="font-black text-gray-900">At Home 北長瀬</div>
                  <div className="text-gray-700 font-medium">
                    〒700-0962<br />
                    岡山県岡山市北区北長瀬表町３丁目2-8
                  </div>
                  <a
                    href="https://www.google.com/maps?q=34.64975,133.88623"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[#0EA5E9] font-bold hover:underline mt-2"
                  >
                    <i className="ri-map-2-line"></i>
                    Googleマップで開く
                  </a>
                </div>
              </div>

              <div className="bg-gradient-to-r from-[#0EA5E9] to-[#38BDF8] rounded-2xl md:rounded-3xl p-5 md:p-6 shadow-xl">
                <div className="text-white font-black mb-2 md:mb-3 text-base md:text-lg">
                  📅 予約受付について
                </div>
                <div className="text-white text-sm md:text-base space-y-1 md:space-y-2 font-medium">
                  <div>毎月20日12:00から翌月分の予約受付開始</div>
                  <div className="text-[#E0F2FE] font-bold">※先着順・公式LINEより受付</div>
                </div>
              </div>
              <div className="flex flex-wrap gap-3 md:gap-4">
                <button
                  onClick={openLineRegistration}
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#06C755] to-[#00B900] text-white font-bold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
                >
                  <i className="ri-line-fill"></i>
                  公式LINE登録
                </button>
                <button
                  onClick={() => setShowContactForm(true)}
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white font-bold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
                >
                  お問い合わせフォーム
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              <div className="bg-[#E0F2FE] border-l-4 border-[#0EA5E9] p-3 md:p-4 rounded-lg">
                <p className="text-sm md:text-base text-gray-700 font-medium">
                  <i className="ri-information-line text-[#0EA5E9] mr-2"></i>
                  初月の3月は全クラス無料開講！要予約・各クラス6名まで
                </p>
              </div>
            </div>
            <div className="space-y-6">
              {/* Google Map */}
              <div className="rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border-2 md:border-4 border-white h-64 md:h-80">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.5!2d133.88623!3d34.64975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDM4JzU5LjEiTiAxMzPCsDUzJzEwLjQiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="At Home 北長瀬 地図"
                ></iframe>
              </div>
              <div className="grid grid-cols-2 gap-4 md:gap-6">
                <div className="relative h-48 md:h-64 rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border-2 md:border-4 border-white">
                  <img
                    src="https://readdy.ai/api/search-image?query=happy%20japanese%20children%20doing%20gymnastics%20mat%20exercises%20in%20bright%20modern%20gym%2C%20smiling%20faces%2C%20energetic%20and%20joyful%20atmosphere%2C%20professional%20sports%20photography%2C%20clean%20white%20background%2C%20warm%20natural%20lighting&width=400&height=500&seq=athome010&orientation=portrait"
                    alt="楽しそうな子どもたち"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="relative h-48 md:h-64 rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border-2 md:border-4 border-white">
                  <img
                    src="https://readdy.ai/api/search-image?query=group%20of%20cheerful%20japanese%20children%20celebrating%20success%20in%20sports%20training%2C%20high%20five%20and%20smiling%20faces%2C%20bright%20modern%20gym%20facility%2C%20fun%20and%20positive%20atmosphere%2C%20professional%20photography%2C%20clean%20background&width=400&height=500&seq=athome011&orientation=portrait"
                    alt="子どもたちの笑顔"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Modal */}
      {showContactForm && (
        <div
          className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6"
          onClick={() => setShowContactForm(false)}
        >
          <div
            className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-8 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-8">
              <h3 className="text-2xl font-black text-gray-900">
                お問い合わせ 📧
              </h3>
              <button
                onClick={() => setShowContactForm(false)}
                className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-close-line text-2xl text-gray-900"></i>
              </button>
            </div>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d5md6d7pl7huldvcii0g"
              method="POST"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);

                fetch('https://readdy.ai/api/form/d5md6d7pl7huldvcii0g', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: new URLSearchParams(
                    formData as unknown as Record<string, string>
                  ).toString(),
                })
                  .then((response) => {
                    if (response.ok) {
                      alert(
                        'お問い合わせありがとうございます。担当者より折り返しご連絡させていただきます。'
                      );
                      form.reset();
                      setShowContactForm(false);
                    } else {
                      alert('送信に失敗しました。もう一度お試しください。');
                    }
                  })
                  .catch(() => {
                    alert('送信に失敗しました。もう一度お試しください。');
                  });
              }}
              className="space-y-6"
            >
              <div>
                <label className="block text-base font-bold text-gray-900 mb-2">
                  お名前 *
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] text-base font-medium"
                  placeholder="山田太郎"
                />
              </div>
              <div>
                <label className="block text-base font-bold text-gray-900 mb-2">
                  メールアドレス *
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] text-base font-medium"
                  placeholder="example@email.com"
                />
              </div>
              <div>
                <label className="block text-base font-bold text-gray-900 mb-2">
                  電話番号 *
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] text-base font-medium"
                  placeholder="090-1234-5678"
                />
              </div>
              <div>
                <label className="block text-base font-bold text-gray-900 mb-2">
                  お子様の年齢
                </label>
                <input
                  type="text"
                  name="child_age"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] text-base font-medium"
                  placeholder="6歳"
                />
              </div>
              <div>
                <label className="block text-base font-bold text-gray-900 mb-2">
                  お問い合わせ内容 *
                </label>
                <textarea
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] text-base resize-none font-medium"
                  placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                  onChange={(e) => {
                    const remaining = 500 - e.target.value.length;
                    const counter = e.target
                      .closest('div')
                      ?.querySelector('.char-counter');
                    if (counter) {
                      counter.textContent = `残り${remaining}文字`;
                    }
                  }}
                ></textarea>
                <div className="text-sm text-gray-500 mt-1 char-counter font-medium">
                  残り500文字
                </div>
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white py-4 rounded-full font-black text-base hover:shadow-xl transition-all whitespace-nowrap cursor-pointer shadow-lg"
              >
                送信する
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-gradient-to-br from-[#0EA5E9] to-[#0284C7] text-white py-12 md:py-16 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
            <div className="space-y-3 md:space-y-4">
              <img
                src="https://public.readdy.ai/ai/img_res/e1380804-54cc-4536-9b28-15a605cfd3a4.png"
                alt="At体育塾岡山・北長瀬校"
                className="h-10 md:h-14 w-auto drop-shadow-lg"
              />
              <p className="text-sm md:text-base text-white/90 font-medium">
                岡山の子供たちから日本に活力を!! ✨
              </p>
              <button
                onClick={openLineRegistration}
                className="inline-flex items-center gap-2 bg-white text-[#0EA5E9] font-bold text-sm md:text-base px-5 md:px-6 py-2.5 md:py-3 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-line-fill"></i>
                公式LINE登録
              </button>
            </div>
            <div>
              <h4 className="font-black mb-3 md:mb-4 text-base md:text-lg">
                メニュー
              </h4>
              <div className="space-y-1.5 md:space-y-2 text-sm md:text-base font-medium">
                <button
                  onClick={() => scrollToSection('home')}
                  className="block hover:underline cursor-pointer whitespace-nowrap"
                >
                  ホーム
                </button>
                <button
                  onClick={() => scrollToSection('about')}
                  className="block hover:underline cursor-pointer whitespace-nowrap"
                >
                  謲師紹介
                </button>
                <button
                  onClick={() => scrollToSection('curriculum')}
                  className="block hover:underline cursor-pointer whitespace-nowrap"
                >
                  カリキュラム
                </button>
                <button
                  onClick={() => scrollToSection('schedule')}
                  className="block hover:underline cursor-pointer whitespace-nowrap"
                >
                  料金・スケジュール
                </button>
              </div>
            </div>
            <div>
              <h4 className="font-black mb-3 md:mb-4 text-base md:text-lg">
                お問い合わせ
              </h4>
              <div className="space-y-1.5 md:space-y-2 text-sm md:text-base font-medium">
                <div>At Home 北長瀬</div>
                <div>（鍼灸・整体院）内</div>
                <div className="pt-1 md:pt-2">
                  <a
                    href="tel:086-239-5959"
                    className="flex items-center gap-2 hover:underline whitespace-nowrap"
                  >
                    <i className="ri-phone-fill"></i>
                    086-239-5959
                  </a>
                </div>
                <div className="pt-1 md:pt-2">
                  <button
                    onClick={() => setShowContactForm(true)}
                    className="hover:underline cursor-pointer whitespace-nowrap"
                  >
                    お問い合わせフォーム
                  </button>
                </div>
                <div className="pt-1 md:pt-2">
                  <a
                    href="http://at-home-kitanagase.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline whitespace-nowrap"
                  >
                    At Home 北長瀬サイト
                  </a>
                </div>
              </div>
            </div>
            <div>
              <h4 className="font-black mb-3 md:mb-4 text-base md:text-lg">
                予約方法
              </h4>
              <div className="space-y-1.5 md:space-y-2 text-sm md:text-base font-medium">
                <div>公式LINEに登録</div>
                <div>予約ページから予約</div>
                <div className="pt-1 md:pt-2">
                  <a
                    href="tel:086-239-5959"
                    className="flex items-center gap-2 hover:underline whitespace-nowrap"
                  >
                    <i className="ri-phone-fill"></i>
                    お電話でも受付
                  </a>
                </div>
                <div className="text-xs md:text-sm text-white/80 pt-1 md:pt-2">
                  初月の3月は全クラス無料開講
                </div>
                <div className="text-xs md:text-sm text-white/80">
                  ※要予約・各クラス6名まで
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-white/20 pt-6 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4 text-sm md:text-base font-medium">
            <div>&copy; 2025 At体育塾岡山・北長瀬校. All rights reserved.</div>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
